export default __webpack_public_path__ + "cedb1e5f1a535d532a2da1121a8fd598.webp";